import React, {Component, createRef} from 'react';
import PropTypes from 'prop-types';

import GDTReeSingle from './gd-tree-single'
import GDTReeMultiselect from './gd-tree-multiselect'
import CreateTreeOptions from 'core/gd/structure-control/create-tree-options'
import {ConstProject} from "../../gd/const/project"
import {ProjectSystemType} from "../../model2/project/types"

export default class GDTree extends React.Component {

    static propTypes = {
        renderType: PropTypes.oneOf(["default", "filter"]),

        source: PropTypes.object,
        companies: PropTypes.array,
        parentsFor: PropTypes.oneOf([
            "common-use",
            "event",
            ConstProject.type.PROJECT,
            ConstProject.type.WORKFOLDER,
            ConstProject.type.BACKLOG,
            ConstProject.type.SPRINT,
            ConstProject.type.TAG,
            "task",
            "user",
            "report",
            "tagFilter",
            'document'
        ]),
        expanded: PropTypes.shape({
            companies: PropTypes.array,
            projects: PropTypes.array
        }),

        //for single only
        value: PropTypes.shape({
            companyId: PropTypes.string,
            projectId: PropTypes.string
        }),

        //for multiselect only
        values: PropTypes.shape({
            companies: PropTypes.array,
            projects: PropTypes.array
        }),

        filterProjects: PropTypes.arrayOf(PropTypes.shape({
            counter: PropTypes.number,
            item: PropTypes.object
        })),
        ignoredParentProjects: PropTypes.array,             //ids of parent projects not to be shown in tree, its children level is shifted one level up

        unselectLabel: PropTypes.string,                    //for single tree only
        selectable: PropTypes.bool,                         //for single tree only

        companiesSelectable: PropTypes.bool,
        singleCompanyVisible: PropTypes.bool,
        showEmptyCompanies: PropTypes.bool,
        showOnlyFilterProjects: PropTypes.bool,
        showGhostParents: PropTypes.bool,
        showCompanyIcon: PropTypes.bool,
        showProjectIcon: PropTypes.bool,
        showProjectIconColorized: PropTypes.bool,
        noCollapseExpand: PropTypes.bool,
        filterByAccess: PropTypes.bool,
        scrollContentStyle: PropTypes.object,
        multiselect: PropTypes.bool,
        inheritedChildrenSelection: PropTypes.bool,
        multiselectDifferLabelAndCheckboxClick: PropTypes.bool,
        multiselectCheckboxType: PropTypes.oneOf(['default','full-colored','filled']),
        multiselectCheckboxSize: PropTypes.oneOf(['normal','normal-14','small']),
        accessLevels: PropTypes.array,
        autoExpandParentsOfSelected: PropTypes.bool,        //for multiselect tree only
        updateExpandedOnReceiveProps: PropTypes.bool,
        noScroll: PropTypes.bool,
        scrollToSelected: PropTypes.bool,                   //for single tree only
        highlightOnHover: PropTypes.bool,

        onToggleExpand: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        onTab: PropTypes.func,
    };

    static defaultProps = {
        renderType: 'default',
        // source: gd.tree,
        multiselect: false,
        multiselectCheckboxType: 'default'
    };

    constructor(props) {
        super(props)

        this.gdTreeRef = createRef()
    }

    _getParentItems = () => {

        const source = this.props.source || gd.tree;

        const createTreeOptions = new CreateTreeOptions(this.props.companies, {filterByAccess: this.props.filterByAccess});

        let filteredTree;
        switch (this.props.parentsFor){
            case "document":
            case "task":
            case "event":
                filteredTree = createTreeOptions.newTask(this.props.accessLevels, source);
                break;

            case ProjectSystemType.PROJECT:
            case ProjectSystemType.BACKLOG:
            case ProjectSystemType.SPRINT:
            case ProjectSystemType.TAG:
            case ProjectSystemType.FOLDER:
            case "user":
            case "report":
            case "tagFilter":
            default:
                filteredTree = createTreeOptions.newProject(this.props.parentsFor, this.props.accessLevels, source);
                break;
        }

        return filteredTree;
    };

    onKeyDown = (event) => {
        this.gdTreeRef.current.onKeyDown(event)
    }

    render() {
        const Component = this.props.multiselect ? GDTReeMultiselect : GDTReeSingle;

        //always expand single company
        const expandedUpdated = this.props.expanded ? this.props.expanded : {companies:[],projects:[]};
        if (this.props.companies && this.props.companies.length === 1) {
            expandedUpdated.companies = _.uniq(expandedUpdated.companies.concat(this.props.companies));
        }

        return (
            <Component ref                                      = {this.gdTreeRef}
                       className                                = {Classes(this.props.className, this.props.renderType+"-type")}
                       source                                   = {this.props.source || gd.tree}
                       filterByAccess                           = {this.props.filterByAccess}
                       companies                                = {this._getParentItems()}
                       expanded                                 = {expandedUpdated}
                       value                                    = {this.props.value}
                       values                                   = {this.props.values}
                       filterProjects                           = {this.props.filterProjects}
                       ignoredParentProjects                    = {this.props.ignoredParentProjects}
                       unselectLabel                            = {this.props.unselectLabel}
                       singleCompanyVisible                     = {this.props.singleCompanyVisible}
                       showEmptyCompanies                       = {this.props.showEmptyCompanies}
                       companiesSelectable                      = {this.props.companiesSelectable}
                       inheritedChildrenSelection               = {this.props.inheritedChildrenSelection}
                       multiselectDifferLabelAndCheckboxClick   = {this.props.multiselectDifferLabelAndCheckboxClick}
                       multiselectCheckboxType                  = {this.props.multiselectCheckboxType}
                       multiselectCheckboxSize                  = {this.props.multiselectCheckboxSize}
                       showOnlyFilterProjects                   = {this.props.showOnlyFilterProjects}
                       showGhostParents                         = {this.props.showGhostParents}
                       showCompanyIcon                          = {this.props.showCompanyIcon}
                       showProjectIcon                          = {this.props.showProjectIcon}
                       showProjectIconColorized                 = {this.props.showProjectIconColorized}
                       noCollapseExpand                         = {this.props.noCollapseExpand}
                       scrollContentStyle                       = {this.props.scrollContentStyle}
                       autoExpandParentsOfSelected              = {this.props.autoExpandParentsOfSelected}
                       updateExpandedOnReceiveProps             = {this.props.updateExpandedOnReceiveProps}
                       noScroll                                 = {this.props.noScroll}
                       scrollToSelected                         = {this.props.scrollToSelected}
                       selectable                               = {this.props.selectable}
                       highlightOnHover                         = {this.props.highlightOnHover}
                       onToggleExpand                           = {this.props.onToggleExpand}
                       onChange                                 = {this.props.onChange}
                       onTab                                    = {this.props.onTab}>

                {this.props.children}

            </Component>
        );
    }
}
